import * as v from 'valibot';
import { eventBus } from '../event-manager';
import { useParticipantStore } from '../store';
import { ParticipantSchema, type ValueOf } from '../types';
import { EVENT_LISTENER_METHODS } from './constants';

type SendParticipantEventType = Exclude<
  ValueOf<typeof EVENT_LISTENER_METHODS.ParticipantEventsListner>,
  'onParticipantListChanged'
>;

export function sendParticipantEvent(
  type: SendParticipantEventType,
  participantId: string,
) {
  const participant = useParticipantStore
    .getState()
    .getParticipantById(participantId);
  if (participant) {
    const validatedParticipant = v.safeParse(ParticipantSchema, participant);
    if (validatedParticipant.success) {
      eventBus.publish({
        type,
        payload: validatedParticipant.output,
      });
    }
  }
}

export function sendParticipantListChangedEvent() {
  const participants = useParticipantStore.getState().participants;
  const validatedParticipants = v.safeParse(
    v.array(ParticipantSchema),
    participants,
  );
  if (validatedParticipants.success) {
    eventBus.publish({
      type: EVENT_LISTENER_METHODS.ParticipantEventsListner
        .onParticipantListChanged,
      payload: validatedParticipants.output,
    });
  }
}
